/* global axios */
import ApiClient from './ApiClient';

class VersionAPI extends ApiClient {
  constructor() {
    super('version');
  }

  get() {
    return axios.get(this.url);
  }
}

export default new VersionAPI();
